import { Card, Grid, Typography } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import Alert from "@material-ui/lab/Alert/Alert";
import React from "react";
import { Link } from "react-router-dom";
import { routesPaths } from "../../Routes";
import { useGetMeQuery } from "../../api/rtk/MeApi";
import TranslatedMessage from "../translations/TranslatedMessage";

const MandatoryFieldsAlert = () => {
  const { data: me, isFetching: isMeFetching } = useGetMeQuery();

  if (isMeFetching || !me?.hasEmptyPersonalFields) {
    return <></>;
  }

  return (
    <Grid container={true}>
      <Grid item={true} xs={12}>
        <Card>
          <Alert icon={<ErrorIcon />} color="info">
            <Typography>
              <TranslatedMessage id="home.myAlertFields" />{" "}
              <Link to={routesPaths.userProfile()}>
                <TranslatedMessage id="home.myAlertFields.link" />
              </Link>
            </Typography>
          </Alert>
        </Card>
      </Grid>
    </Grid>
  );
};

export default MandatoryFieldsAlert;
